<div class="container">
    <div class="premium-access-content">
        <h2>Apply Online Admission By Filling Up E-Form</h2>
        <a class="default-btn cursor-pointer" (click)="applyForAdmission()">Explore Courses<span></span></a>
        <p>Wish to know more about Admissions and Updates?</p>
        <ul class="social-link">
            <li><a href="https://www.facebook.com/share/1Z3NKD3iQV/" class="d-block" target="_blank"><i class="fa-brands fa-facebook-f white-icon"></i></a>
            </li>
            <li><a href="https://www.instagram.com/successparamedical?igsh=MXBicjlmcnEzc2g4MQ==" class="d-block" target="_blank"><i class="fa-brands fa-instagram white-icon"></i></a>
            </li>
            <li><a href="tel:+919924018454" class="d-block" target="_blank"><i class="fa-brands fa-whatsapp white-icon"></i></a>
            </li>
        </ul>
    </div>
</div>